"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const clsx_1 = __importDefault(require("clsx"));
const common_1 = require("@Const/common");
const react_1 = __importDefault(require("react"));
const WizardStepIndicator = ({ index, currentIndex, stepIndicator }) => {
    const displayDoneIconAction = stepIndicator.displayFinishedIconAction || 'after';
    const stepIsCompleted = () => {
        if (displayDoneIconAction === 'after') {
            return index < currentIndex;
        }
        else {
            return index <= currentIndex;
        }
    };
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('step-indicator-container', index === currentIndex && 'active') },
        react_1.default.createElement("div", { className: 'step-indicator-icon-background' },
            react_1.default.createElement("img", { className: (0, clsx_1.default)('step-indicator-icon', index === currentIndex && 'active'), src: stepIsCompleted() ? common_1.ICONS.review : stepIndicator.icon, alt: `step indicator icon for ${stepIndicator.label}` })),
        react_1.default.createElement("div", { className: (0, clsx_1.default)('step-indicator-label', index === currentIndex && 'active') }, stepIndicator.label)));
};
exports.default = WizardStepIndicator;
